import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper'

export default function QualityCheckOverviewTable(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [VNG, setVNG] = useState(false)

    const rows = props.qualitySamples.sort((a, b) => new Date(b.samples[0].date) - new Date(a.samples[0].date)).map(x => {
        let withinTolerance = true
        var i;

        var sequence = 1
        for (i = 0; i < x.samples.length; i++) {
            if (!x.samples[i].resultOk) {
                withinTolerance = false;
            }
        }
        if (x.carrierInfo.bookingSequence === -1) {
            sequence = "*VNG"
            if(!VNG){
                setVNG(true)
            }
        }
        else{
            sequence = sequence + x.carrierInfo.bookingSequence
        }
       

        return (createData(x.samples[0].date, sequence, withinTolerance, x.samples[0].operator))
    }
    )

    function createData(date, palletSequence, withinTolerance,operator) {

        return { date, palletSequence, withinTolerance ,operator};
    }

    return (
        <div>
          <div className={classes.qualityChecksTable}>
            <Table className={classes.table} aria-label="customizedtable">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headCell}>{t("Date")}</TableCell>
                        <TableCell className={classes.headCell}>Operator</TableCell>
                        <TableCell className={classes.headCell}>{t("Pallet")}</TableCell>
                        <TableCell className={classes.headCell}>{t("Within tolerance")}</TableCell>
                        <TableCell className={classes.headCell}></TableCell>
                    </TableRow>
                </TableHead>
                {rows.length > 0 ?
                <TableBody> 
                    {rows.filter(x => x !== null).map((row, index) => (
                        <TableRow key={index} className={classes.row}>
                            <TableCell className={classes.infoCell} style={{ width: "20%" }}>{fromNewDateFormatToDDMMYYYYHHmmssSlash(row.date)}</TableCell>
                            <TableCell className={classes.infoCell}>{row.operator}</TableCell>
                            <TableCell className={classes.infoCell} style={{ width: "20%" }}>{row.palletSequence + "/" + props.totalPallets}</TableCell>
                            <TableCell className={classes.infoCell} align="right">{row.withinTolerance ?
                                <img className={classes.check} src={process.env.PUBLIC_URL + '/img/greenCheck.svg'} alt={""}></img> :
                                <svg className={classes.check} xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 121.31 122.876" enableBackground="new 0 0 121.31 122.876"><g><path fillRule="evenodd" fill="#D84949" clipRule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z" /></g></svg>
                            }  </TableCell>
                            <TableCell className={classes.infoCell} align="right"><button className={classes.detailButton} onClick={() => props.showDetails(row.date)}><img className={classes.eye} src={process.env.PUBLIC_URL + '/img/eye.svg'} alt={""}></img></button></TableCell>
                        </TableRow>
                    ))}
                </TableBody>: <TableBody></TableBody> }
            </Table>
            {VNG && <div className = {classes.vng}>{t("* Volgnummer niet gekend, volgnummer wordt uitgereikt na de boeking van de pallet")}</div>}
       
        </div>  
        {rows.length === 0 ?
                <div className={classes.noQualityChecks}>
                    {t("NoQualityChecks")}
                </div> 
            : ''}
        </div>
    )
}

const useStyles = makeStyles({
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    qualityChecksTable: {
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "6px",
        marginLeft: "5px"
    },
    noQualityChecks: {
        padding: '10px',
        border: '1px dashed grey',
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        marginTop: '5px',
        marginLeft: '5px',
        borderRadius: "6px",

    },
    infoCell: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "10px",
        paddingTop: "10px"
    },
    headCell: {
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "0px"
    },
    check: {
        float: 'left',
        marginLeft: "40px",
        width: "20px"
    },
    detailButton: {
        border: "none",
        outline: "none",
        cursor: 'pointer',
        backgroundColor: "rgb(1,1,1,0)"
    },
    vng:{
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        paddingTop:"10px"
    }
});